import { z } from 'zod'

const urlOrFallback = (url: string) => {
  try {
    new URL(url)
    return url
  } catch {
    return 'https://assets.coingecko.com/coins/images/4128/large/solana.png?16965'
  }
}

const CryptoInfo = z.object({
  id: z.string(),
  symbol: z.string(),
  name: z.string(),
  image: z.string().transform(urlOrFallback),
  current_price: z.number().safe(),
  market_cap: z.number().safe(),
  market_cap_rank: z.number().safe(),
  fully_diluted_valuation: z.number().safe().nullable(),
  total_volume: z.number().safe(),
  high_24h: z.number().safe(),
  low_24h: z.number().safe(),
  price_change_24h: z.number().safe(),
  price_change_percentage_24h: z.number().safe(),
  market_cap_change_24h: z.number().safe(),
  market_cap_change_percentage_24h: z.number().safe(),
  circulating_supply: z.number().safe(),
  total_supply: z.number().safe().nullable(),
  max_supply: z.number().safe().nullable(),
  ath: z.number().safe(),
  ath_change_percentage: z.number().safe(),
  ath_date: z.string().refine(
    (value) => {
      const date = new Date(value)
      return !isNaN(date.getTime())
    },
    {
      message: 'Invalid date format',
    },
  ),
  atl: z.number().safe(),
  atl_change_percentage: z.number().safe(),
  atl_date: z.string().refine(
    (value) => {
      const date = new Date(value)
      return !isNaN(date.getTime())
    },
    {
      message: 'Invalid date format',
    },
  ),
  roi: z.union([z.null(), z.any()]), // Replace z.any() with the appropriate type if known
  last_updated: z.string().refine(
    (value) => {
      const date = new Date(value)
      return !isNaN(date.getTime())
    },
    {
      message: 'Invalid date format',
    },
  ),
})

const SearchPartialCryptoInfo = CryptoInfo.pick({
  id: true,
  symbol: true,
  name: true,
  image: true,
})

const PartialCryptoInfo = z.object({
  id: z.string(),
  symbol: z.string(),
  name: z.string(),
  image: z.string().transform(urlOrFallback),
  currentPrice: z.number().safe(),
  homepage: z.string().nullable(),
  baseLayerId: z.string().nullable(),
  tgeDate: z.string().nullable(),
  maxSupply: z.number().safe().nullable(),
  fdv: z.number().safe().nullable(),
})

export const GetCoinsResponseBody = z.object({
  coins: z.array(SearchPartialCryptoInfo),
})

export const GetCryptoInfoResponseBody = z.object({
  coin: PartialCryptoInfo,
})

export type CryptoInfo = z.infer<typeof PartialCryptoInfo>
